import { render } from "./basic_button.vue?vue&type=template&id=34fcc7cb&ts=true"
import script from "./basic_button.vue?vue&type=script&lang=ts"
export * from "./basic_button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__